module.exports = __webpack_public_path__ + "static/media/sync.24a6085f.svg";